module.exports = __webpack_public_path__ + "static/media/aboutImg2.006d40d6.png";